"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribedObject = exports.PUSHClientMessage = exports.AsyncException = exports.AAPIRequest = exports.GBEHeader = void 0;
class GBEHeader {
    constructor() {
        this.version = 2;
        this.fragmentLanguage = 'Javascript';
        this.fragmentVersion = '';
        this.clientIdentifier = 'GEC';
    }
}
exports.GBEHeader = GBEHeader;
class AAPIRequest {
    constructor(params) {
        this.header = GBEHeader;
        this.callbackOnSuccess = params.callbackOnSuccess;
        this.callbackOnException = params.callbackOnException;
    }
}
exports.AAPIRequest = AAPIRequest;
class AsyncException {
    constructor(params) {
        this.returnCode = params.returnCode;
        this.message = 'unknown error';
    }
}
exports.AsyncException = AsyncException;
class PUSHClientMessage {
    constructor(data) {
        this.fields = [];
        this.payload = data.replace(/AAPI\//, '\u0003');
        const messagePairs = this.payload.split('\u0001');
        const headers = messagePairs[0].split('\u0002');
        this.isInitialLoad = headers[2] === 'T';
        //var isChange = headers[2] === "F";
        this.isDelete = headers[2] === 'X';
        for (let i = 1; i < messagePairs.length; i = i + 1) {
            this.fields.push(messagePairs[i]);
        }
        this.topic = messagePairs[0]
            .substring(0, messagePairs[0].indexOf('\u0002'))
            .trim();
        this.header = messagePairs[0].substring(0, messagePairs[0].lastIndexOf('\u0002'));
    }
    isInitialTopicLoad() {
        return this.isInitialLoad;
    }
    isDeleteTopic() {
        return this.isDelete;
    }
    getHeader() {
        return this.header;
    }
    getNumberOfRecords() {
        return this.fields.length;
    }
    getFields(i) {
        return this.fields[i].split('\u0002');
    }
    localeTimeString() {
        const now = new Date();
        return now.toISOString();
    }
}
exports.PUSHClientMessage = PUSHClientMessage;
class SubscribedObject {
    constructor() {
        this._delegateCount = 0;
        this._changeDelegates = {};
    }
    addChangeDelegate(delegate) {
        const delegateId = this._delegateCount++;
        this._changeDelegates[delegateId] = delegate;
        return delegateId;
    }
    removeChangeDelegate(delegateId) {
        delete this._changeDelegates[delegateId];
    }
    fireOnChangeDelegates(newObject, changes) {
        for (const delegate in this._changeDelegates) {
            this._changeDelegates[delegate](newObject, changes);
        }
    }
}
exports.SubscribedObject = SubscribedObject;
